<template>
    <div class="conmmon-header">
			<div class="index-header" :class="{'mobile':isMobile}">
				<div class=" clearfix main_cont" style="height: 100%">
					<div class="stem-logo fl">
						<img :src="siteLogo" style="width:130px;height:51px" v-if="!!siteLogo"/>
					</div>
					<ul class="clearfix fl">
						<li :class="{ac:pathName=='/index.html'}"><a-link href="index"><p>首页</p><p>首页</p></a-link></li>
						<li :class="{ac:urlName=='help'}"><a-link href="help"><p>课程简介</p><p>课程简介</p></a-link></li>
						<li :class="{ac:((pathName=='/index_courses.html')||(pathName=='/project_detail.html'))}">
							<Dropdown  trigger="hover" class="top-dropdown" @on-click="topDropdownClickHandle" @on-visible-change="dropDownVisibleChange">
								 <a-link >
									<p :class="{'dropdown-title-active':isActiveDropdownTitle}">在线课程 <span> <img class="dropdown-icon" :src="headerCourseIcon" > </span> </p>
								 </a-link>
								 <DropdownMenu slot="list">
										<DropdownItem name="1" >STEM项目学习 </DropdownItem>
									  <!-- <DropdownItem name="1" devided>献礼建党百年</DropdownItem> -->
									  <DropdownItem name="2" divided >人工智能</DropdownItem>
									  <DropdownItem name="3" divided >智慧农业</DropdownItem>
									  <DropdownItem name="4" divided >幼儿科学实验</DropdownItem>
								</DropdownMenu>
							</Dropdown>
						</li>
						<li :class="{ac:((pathName=='/index_resources.html')|| (pathName == '/resource_detail.html'))}"><a-link href="/index_resources"><p>参考资料</p><p>参考资料</p></a-link></li>
						<li :class="{ac:((pathName=='/index_inspiration.html')||(pathName =='/inspiration_desc.html'))}"><a-link href="/index_inspiration"><p>课程灵感</p><p>课程灵感</p></a-link></li>
						<li :class="{ac:((pathName=='/index_news.html')|| (pathName=='/news_desc.html')) }"><a-link href="index_news"><p>专栏资讯</p><p>专栏资讯</p></a-link></li>
					</ul>
					<div class="fr right-btns" v-show="isLogin">
						
						<Poptip trigger="hover" title="" content="content">
							<a href="/ucenter.html#/ucenter/mycollection">
								<img class="default-avator fl mr25"
								:src='avatarUrl'
								/>
							</a>
							<div  class="ucenter" slot="content">
								<ul>
									<li><a href="/ucenter.html#/ucenter/myaccount">个人资料</a></li>
									<li><a href="/ucenter.html#/ucenter/mycollection">我的收藏</a></li>
									<li><a href="/ucenter.html#/ucenter/courseActivationList">激活管理</a></li>
									<li><a :href='lastViewCourseUrl?lastViewCourseUrl: "/ucenter.html#/ucenter/mycollection"'>立即上课</a> </li>
									<li @click="logout" style="cursor:pointer">退出</li>
								</ul>
							</div>
						</Poptip>
					</div>
					<div class="fr right-btns" v-show="!isLogin">
						<img class="default-avator fl" src="../../assets/images/index/default_avator.png" alt="" >
						<button class="fl" @click="loginOpen('login')">登录</button>
						<span class="fl">|</span>
						<button class="fl"  @click="loginOpen('register')">注册</button>
					</div>
				</div>
			</div>
			<Modal v-model="login_model" width="450" class="login_model" :mask-closable="false">
				<Login :is-modal="login_model"  :show = "showLogin" @login-in="setLoginIn" @set-show="loginOpen"></Login>
				<div slot="footer">
				</div>
			</Modal>
    </div>
</template>
<script>
import '@assets/font-awesome-4.7.0/css/font-awesome.min.css';
import ALink from '@base/ALink.vue';
import Login from '@components/login/new_login.vue';
import Cookies from 'js-cookie';
import '@css/base.scss';
import './header.scss';
import Bus from '../../pages/project_detail/bus.js';

const headerCourseIconDown = require('../../assets/images/header/xia@2x.png');
const headerCourseIconUp = require('../../assets/images/header/shang@2x.png');

export default {
	name: 'new-header',
	props: {},
	data() {
		return {
			urlName: '',
			siteLogo:'',
			pathName: '',
			isLogin: false,
			teacherName: '',
			showLogin: 'login',
			login_model: false,
			isMobile: false,
			avatarUrl: require("../../assets/images/index/default_avator.png"),
			lastViewCourseUrl: '', // 最后浏览的课程url，立即上课的跳转url，若无，跳转我的收藏
            errUrl: ['https://7xqbwh.dl1.z0.glb.clouddn.com/5LWsJmu5e82kAchfile'], // 错误的头像地址
			headerCourseIcon:headerCourseIconDown,
			isActiveDropdownTitle:false
		

		};
	},
	mounted() {
		let href = window.location.href;
		let hrefAtt = href.split('/');
		this.urlName = hrefAtt[hrefAtt.length - 1].split('.htm')[0] || 'index';
		this.pathName = window.location.pathname;
		this.getTeacherName();
		this.getProjectConfig();
		let u = window.navigator.userAgent;
		this.isMobile = !!u.match(/AppleWebKit.*Mobile.*/);
		this.$emit('avatar-url',this.avatarUrl);
		Bus.$on('showLoginDialog', () => {
			console.log('显示登录窗口');
			this.showLogin = 'login';
			this.login_model = true;
		});
	},
	watch: {
		isLogin() {
			if (this.isLogin) {
				// this.getTeacherName();
				// 获取最后浏览的课程
				this.getLastView();
			}
		},
	},
	methods: {
		topDropdownClickHandle(name){
			console.log("name",name);
			if(name==1){
				window.location.href = './index_courses.html'
			}else if(name==2){
				window.location.href = './ai.html'
			}else if(name==3){
				window.location.href = './ai_agriculture.html'
			}else if(name==4){
				window.location.href = './youerkexue.html'
			}
		},
		dropDownVisibleChange(visilble){
			console.log("dropDownVisibleChange:" + visilble);
			if(visilble){
				this.headerCourseIcon = headerCourseIconUp;
				this.isActiveDropdownTitle = true;
			}else{
				this.headerCourseIcon = headerCourseIconDown;
				this.isActiveDropdownTitle = false;
			}
		},
		getProjectConfig(){
			this.ajax.get("/web/project/getProjectConfig",null).then(res=>{
				if(res.code == 1 && res.data ){
					this.siteLogo= res.data.siteLogo;
					let sassProjectConfig =  res.data || {};
					Bus.$emit('sassProjectConfigChange',sassProjectConfig);
				}
			})
		},
		getLastView(){
			this.ajax.get("/web/collect/last",null).then(res=>{
				if(res.code == 1 ){
					let lastViewData = res.data || {};
					//"data": {	"lessonId": 0,"schoolbookInfoId": 0,},
					if(typeof lastViewData.lessonId!="undefined"){
						///lesson_preview.html?lessonId=188&bookId=1007
						this.lastViewCourseUrl = "/lesson_preview.html?lessonType=1&lessonId="+ lastViewData.lessonId + "&bookId="+ lastViewData.schoolbookInfoId;
					}
				}
			})
		},
		getTeacherName() {
		 	console.log(this.ajax)
			this.ajax.get(this.aUrl.get_teacher, {}, true).then(res => {
                let defaultHeader = res.data.gender == 2 ? require('@images/default/default-teacher-g.png') : require('@images/default/default-teacher-m.png');
				this.isLogin = true;
				this.teacherName = res.data.teacherName || '';
				this.avatarUrl = res.data.avatarUrl && this.errUrl.indexOf(res.data.avatarUrl) < 0 ?  res.data.avatarUrl : defaultHeader;
                this.$emit('avatar-url',this.avatarUrl);

				//已经登录
				this.$emit('is-login', true);
			}).catch(res => {

			    this.$emit('is-login',false);
			});
		},
		logout() {
			this.$Modal.confirm({
				title: '提示',
				content: `<p >${this.teacherName}老师,是否确定退出</p>`,
				width: '320px',
				onOk: () => {
                    Cookies.remove('stem_ooowin_token');
                    Cookies.remove('stem_ooowin_mark');
					this.ajax.post(this.aUrl.logout, {}, true, () => {
						//退出，回到首页
                        setTimeout(function () {
                            window.location.href = "/index.html";
                            // window.location.reload();
                        },500);
					});
				},
			});
		},
		loginOpen(string) {
			console.log("--newHeader.vue --- loginOpen11---:" + string)
			this.login_model = true;
			this.showLogin = string;
		},
		setLoginIn() {
			this.isLogin = true;
			this.login_model = false;

      this.getTeacherName();
			//登录成功
			//Cookies.set('updatePwdFlag',res.data.updatePwdFlag);
      //密码是否过于简单 ，1 复杂，不需要修改，2 过于简单，需要修改
      //Cookies.set('stem_ooowin_pwdEasy',res.data.stem_ooowin_pwdEasy);
			if(Cookies.get('stem_ooowin_pwdEasy')==2){
				this.$Modal.warning({
					title:'提醒',
					content:'当前密码过于简单，请按要求修改',
					onOk:()=>{
						Cookies.remove('stem_ooowin_pwdEasy');
						window.location.href = "/ucenter.html#/ucenter/myaccount"
					}
				})
			}else if(Cookies.get('updatePwdFlag')==2){
				this.$Modal.warning({
					title:'提醒',
					content:'您已经三个月没有修改密码，请按要求修改密码',
					onOk:()=>{
						Cookies.remove('updatePwdFlag');
						window.location.href = "/ucenter.html#/ucenter/myaccount"
					}
				})
			}
		},
	},
	components: { ALink, Login },
};
</script>
<style lang="scss">
@import '../../assets/css/new_base.scss';

.login_model {
	.ivu-modal-close {
		z-index: 9;
	}
	.ivu-modal-content {
		background-color: transparent;
	}
	.ivu-modal-body {
		height: 400px;
	}
}

.index-header {
	height: 80px;
	line-height: 80px;
	background-color: rgba(0, 0, 0, 0.5);
	position: fixed;
	width: 100%;
	box-sizing: border-box;
	z-index: 999;
	top: 0;
	left: 0;
	font-size: 18px;
	min-width: 1200px;
	a,
	p,
	button,
	span {
		color: #fff;
	}
	button {
		background-color: transparent;
		margin: 0 0.4px * $scale;
	}
	.stem-logo {
		width: 158px;
		margin-right: 1.5px * $scale;
		height: 100%;
		img {
			width: 100%;
			vertical-align: middle;
		}
	}
	ul {
		height: 100%;
	}
	ul li {
		padding: 0 0.2px * $scale;
		overflow: hidden;
		height: 40px;
		line-height: 40px;
		color: #fff;
		margin: 20px 0.5px * $scale;
		a {
			display: block;
			height: 100%;
			transition: all 1s;
		}
	}
	ul li:hover a,
	ul li.ac a {
		margin-top: -40px;
	}
	ul li a p:last-of-type {
		color: #f5af36;
	}
}

.top-dropdown{
	span{
		cursor: pointer;
	}
	.ivu-select-dropdown{
		top: 75px!important;
		background: rgba(0,0,0,0.5)!important;
		border-radius: 0!important;
		.ivu-dropdown-menu{
			li{
				color: #fff!important;
 				margin: 0!important;
				width: 100%;
				font-size: 16px!important;
				text-align: center!important;
				padding: 2px 8px!important;
			}
			li:hover{
				color: #F5AF36!important;
				cursor: pointer!important;
				background: transparent!important;
				font-size: 16px!important;
				text-align: center!important;
				padding: 2px 8px!important;
			}
		}
		.ivu-dropdown-item-divided{
			border-top: 1px solid rgba(255,255,255,0.4)!important;
		}
		.ivu-dropdown-item-divided:before {
			height: 0!important;
		
		}
		
	}
	.dropdown-icon{
		width: 18px;
		height: 10px;
		position: relative;
		top: -2px;
		left: 2px;
	}
	p.dropdown-title-active{
		color:#F5AF36
	}
	
}


/*@media only screen and (max-width: 800px) {
	.index-header.mobile {
		height: 1.5px * $scale;
		line-height: 1.5px * $scale;
		font-size: 15px;
		.stem-logo {
			display: none;
		}
		ul li {
			display: none;
		}
		ul li:nth-of-type(1),
		ul li:nth-of-type(2) {
			display: block;
		}
		ul li.ac:after {
			height: 0.1px * $scale;
		}
		.right-btns {
			font-size: 12px;
			display: none;
		}
	}
}*/
</style>
